import { Form, Row } from "antd";
import { FormInstance, Rule } from "antd/es/form";
import TextArea from "antd/es/input/TextArea";
import { useMemo } from "react";
import { CommentOptions } from "./CommentOptions";
import { PAYMENT_COMMENT_RULE } from "../../../../lib/validationRules";

type CommentsProps = {
  amountOption: number;
  form: FormInstance;
};

export const Comments = ({ amountOption, form }: CommentsProps) => {
  const rules: Rule[] = useMemo(() => {
    return amountOption === 2
      ? [
          {
            required: true,
            message: "Please enter comments",
            validateTrigger: "onSubmit",
          },
          {
            max: 255,
            message: "Comment shouldn't contain more than 255 symbols",
            validateTrigger: "onSubmit",
          },
          {
            pattern: PAYMENT_COMMENT_RULE,
            message: "Comment contains invalid symbols",
            validateTrigger: "onSubmit",
          },
        ]
      : [
          {
            max: 255,
            message: "Comment shouldn't contain more than 255 symbols",
            validateTrigger: "onSubmit",
          },
          {
            pattern: PAYMENT_COMMENT_RULE,
            message: "Comment contains invalid symbols",
            validateTrigger: "onSubmit",
          },
        ];
  }, [amountOption]);

  const placeholder: string = useMemo(
    () =>
      amountOption === 1 ? "" : "Select a tag above or type your instructions",
    [amountOption],
  );

  return (
    <Row className="d-block mt-8">
      <p className="my-0 text-md w-500">
        Comments {amountOption === 1 ? "(optional)" : "(required)"}
      </p>
      <p className="mt-0 mb-4 text-md title">
        Any additional instructions needed to process your payment correctly.
      </p>
      {amountOption === 2 && <CommentOptions form={form} />}
      <Form.Item
        label=" "
        name="comments"
        rules={rules}
        className="comments-form-item mb-10"
      >
        <TextArea placeholder={placeholder} />
      </Form.Item>
    </Row>
  );
};
